// @flow

import React, { Component } from 'react';
import Relay from 'react-relay';
import styler from 'react-styling';
import { Grid, Row, Col } from 'react-bootstrap/lib';
import moment from 'moment';
import { observer } from 'mobx-react';
import NProgress from 'react-nprogress';

import { Event, EventLoading, CalendarTables, CalendarHeader } from '../index';
import { filterNotNullEdgeNodes } from '../../libs/Extract';

const style = styler `   
  Table
    height: calc(100% - 177px)
    overflow-y: auto
`;

@observer
class CalendarOverview extends Component {
  state: {
    eventSelected: Object,
    modalShowEvent: boolean,
  } = {
    eventSelected: {},
    modalShowEvent: false,
  }

  props: {
    viewer: Object,
    relay: Object,
    emails: Array<string>,
    startDate: Date,
    endDate: Date,
    languagedata: Object,
    showContactInfoMobile: boolean,
    scrollCalendar: Function,
    setCalendarView: Function,
    calendarView: string,
  }

  _renderEvents = (resources: any, date: moment, enddate?: moment) => {
    let startDate;
    let endDate;
    // week view
    if (enddate) {
      NProgress.start();
      startDate = moment(date).startOf('day').add(1, 'second').unix();
      endDate = moment(enddate).endOf('day').unix();
    } else {
      startDate = moment(date).startOf('day').add(1, 'second').unix();
      endDate = moment(date).endOf('day').unix();
    }
    const events = resources.map((resource, index) =>
      <Relay.Renderer
        environment={Relay.Store}
        Container={Event}
        queryConfig={{
          queries: {
            event: () => Relay.QL`query { viewer }`,
          },
          name: 'EventViewQueries',
          params: {
            emails: [resource.email],
            startDate,
            endDate,
          },
        }}
        // eslint-disable-next-line
        render={({done, error, props, retry, stale}) => {
          if (error) {
            return <p>{error}</p>;
          } else if (props) {
            return (
              <Event
                key={index}
                event={this.props.viewer}
                startDate={startDate}
                endDate={endDate}
                emails={[resource.email]}
                displayName={resource.displayName}
                mode="calendar"
              />);
          }
          if (this.props.calendarView === 'listDay') {
            return (<EventLoading />);
          }
        }}
      />
    );
    return events;
  }

  render() {
    const { languagedata, calendarView } = this.props;
    const { contacts, meetingRooms, otherResources } = this.props.viewer;
    const contactsFiltered = filterNotNullEdgeNodes(contacts);
    const meetingRoomsFiltered = filterNotNullEdgeNodes(meetingRooms);
    const otherResourcesFiltered = filterNotNullEdgeNodes(otherResources);
    const initialContactsSelected = [...contactsFiltered, ...meetingRoomsFiltered, ...otherResourcesFiltered];
    const { endDate, startDate } = this.props.relay.variables;
    return (
      <Grid fluid>
        <Row>
          <Col md={8} className={`user-info ${(this.props.showContactInfoMobile ? ' show-user-info' : '')}`}>
            <CalendarHeader
              languagedata={languagedata}
              calendarView={this.props.calendarView}
              setCalendarView={this.props.setCalendarView}
              scrollCalendar={this.props.scrollCalendar}
              startDate={moment.unix(startDate)}
              endDate={moment.unix(endDate)}
              weekView
              dayView
              monthView={false}
            />
            <div style={style.Table}>
              <CalendarTables
                languagedata={languagedata}
                initialContactsSelected={initialContactsSelected}
                startDate={startDate}
                endDate={endDate}
                renderEvents={this._renderEvents}
                calendarView={calendarView}
              />
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}


export default Relay.createContainer(CalendarOverview, {
  initialVariables: {
    selectedContactEmail: null,
    emails: [null],
    startDate: null,
    endDate: null,
  },
  fragments: {
    viewer: (vars) => Relay.QL`
      fragment on Viewer {
        contact(email: $selectedContactEmail) {
          id
          displayName
          title
          department
          email
          city
        }
        contacts(first: 400, emails: $emails) {
          edges {
            node {
              id
              displayName
              email
            }
          }
        }
        meetingRooms(first: 400, emails: $emails) {
          edges {
            node {
              id
              displayName
              email
            }
          }
        }
        otherResources(first: 400, emails: $emails) {
          edges {
            node {
              id
              displayName
              email
            }
          }
        }
        ${Event.getFragment('event', vars)},
      }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Components/Calendar/CalendarOverview.js